<template>
    <div  style="height:inherit" class="leftclass">
            <!-- @open="handleOpen"
          @close="handleClose" -->
      <img src="../../assets/images/logo01.png" alt="" class="sider-logo">
          <div class="menu-list">
            <div class="rowlist" v-for="(item,index) in treedata" :key = "item.id"
            :class="{current:active==index}"
            @click='openchilden(index,item.name,item.children)'
            >
               <i :class="item.icon"></i>
              <span slot="title">{{item.title}}</span>
            </div>
               <div class="cosspan">
                <div v-for="(item,index) in treedata" :key = "item.name">
                  <div class="cosspan-tit"  v-if="active == index">
                  {{item.title}}
                </div>
                <el-collapse v-model="activeNames" v-if="active == index">
                  <div class="" v-for="(childItem,childIndex) in item.children" :key="childItem.id">
                  <el-collapse-item  :name="childItem.id" v-if="childItem.children">
                     <template slot="title">
                        <el-tooltip class="item" effect="dark" :content="childItem.title" placement="right">
                      <div class="nwap">
                        {{childItem.title}}
                      </div>
                        </el-tooltip>
                     </template>
                     <div class="childItem-item"  
                     v-for="childItemC in childItem.children" 
                      :key='childItemC.id'
                      :index="childItemC.name"
                      @click="openViews(childItemC.name,childItemC.title)"
                      :class="{chcurrent:chative == childItemC.name}"
                      >
                       <el-tooltip class="item" effect="dark" :content="childItemC.title" placement="right">
                      <div class="nwap">
                         {{childItemC.title}}
                      </div>
                       </el-tooltip>
                      </div>
                  </el-collapse-item>
                  <div v-else class="elsetit" :class="{chcurrent:chative == childItem.name}"
                  @click="openViews(childItem.name,childItem.tile)"
                  >
                    <el-tooltip class="item" effect="dark" :content="childItem.title" placement="right">
                      <div class="nwap">
                         {{childItem.title}}
                      </div>
                       </el-tooltip>
                  </div>
                    </div>
                </el-collapse>
                </div>
              </div>
          </div>
          <!-- 
  
           -->
          <!-- <el-menu
                :default-active="onRoutes"
                router
                class="el-menu-vertical-demo"
                 :collapse="isCollapse"
                 mode="vertical">
                 <template  v-for="(item,index) in treedata">
                       <el-menu-item
                        v-if="!item.children"
                        :key = "item.name"
                        :index = 'item.name'
                       >
                        <i :class="item.icon"></i>
                         <span slot="title">{{item.title}}</span>
                        </el-menu-item>
                    <el-submenu :index="item.name" v-else>              
                    <template slot="title">
                    <i :class="item.icon"></i>
                    <span>{{item.title}}</span>
                    </template>
                    <template   v-for="childItem in item.children" >
                    <el-submenu
                      v-if="childItem.children"
                      :key='childItem.id'
                      :index="childItem.name"
                    >
                     <template slot="title">
                         <i :class="childItem.icon"></i>
                         <span slot="title">{{childItem.title}}</span>
                    </template>

                     <el-menu-item 
                      v-for="childItemC in childItem.children" 
                      :key='childItemC.id'
                      :index="childItemC.name"
                    >{{childItemC.title}}</el-menu-item>
                    </el-submenu>
                    <el-menu-item-group v-else>
                        <el-menu-item :index="childItem.name">{{childItem.title}}</el-menu-item>
                    </el-menu-item-group>
                     </template>
                </el-submenu>
                        </template>
                </el-menu> -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
     computed: {
    // ...mapGetters([
    //   'permission_routes',
    //   'sidebar'
    // ]),
    //   showLogo() {
    //   return this.$store.state.settings.sidebarLogo
    // },
    // variables() {
    //   return variables
    // },
    // isCollapse() {
    //   return !this.sidebar.opened
    //   // return true
    // },
    // onRoutes(){
    //   let _tmp = this.$route.matched,
    //       _len = _tmp.length - 1,
    //       _path = _tmp[_len].path
    //   if(_tmp[_len].meta.parent){
    //   return _tmp[_len].meta.parent.path
    //     // return '/' + _path.split('/')[1]
    //   }else{
    //      return this.$route.path
    //   }
    //   // console.log()
    // //  return this.$route.path
    // },
     opened() {
                return this.treedata[this.active].children.map((i) => {
                    return i.id;
                });
            }
},
	data(){
		return {
      activeNames:[],
        chative:'',
        active:'',
        titname:'',
        treedata: [
                {
                icon:'icon-al-qiyeguanli',
                name:'/businessList',
                path:'',
                title:'企业管理',
                id:'1',
                children:[{
                icon:'icon-al-qiyeguanli',
                name:'/businessInfo',
                path:'',
                title:'企业信息',
                id:'10', 
                parentId:'1',
                children:[{
                icon:'',
                name:'/businessList',
                path:'',
                title:'企业列表',
                id:'101', 
                parentId:'10',
                
                },
                {
                icon:'',
                name:'/businessAdmin',
                path:'',
                title:'企业管理员',
                id:'103', 
                parentId:'10',
                
                },
                {
                icon:'',
                name:'/businessType',
                path:'',
                title:'企业分类',
                id:'102', 
                parentId:'10',
                }
                ]
                },
                ]
            },{
                icon:'icon-al-question-circle',
                name:'/helpList',
                path:'',
                title:'帮助管理',
                id:'2', 
                 children:[{
                    icon:'',
                    name:'/helpList',
                    path:'',
                    title:'帮助列表',
                    id:'20', 
                    parentId:'2',
                 }]
            },
            {
              icon:'icon-al-database-set',
              name:'/Application',
              path:'',
              title:'应用管理',
              id:'3', 
                children:[{
                    icon:'',
                    name:'/Application',
                    path:'',
                    title:'应用管理',
                    id:'30', 
                    parentId:'3',
                     children:[{
                     icon:'',
                    name:'/Application',
                    path:'',
                    title:'应用列表',
                    id:'301', 
                    parentId:'30',
                     },
                     {
                     icon:'',
                    name:'/ApplicationType',
                    path:'',
                    title:'应用分类',
                    id:'302', 
                    parentId:'30',
                     },{
                     icon:'',
                    name:'/ApplicationLog',
                    path:'',
                    title:'应用日志',
                    id:'303', 
                    parentId:'30',
                     }
                     ]
                 },{
                    icon:'',
                    name:'/AppConditions',
                    path:'',
                    title:'仿真规则',
                    id:'31', 
                    parentId:'3',
                    children:[{
                       icon:'',
                    name:'/AppConditions',
                    path:'',
                    title:'工况列表',
                    id:'311', 
                    parentId:'31',
                    },{
                       icon:'',
                    name:'/AppAlarm',
                    path:'',
                    title:'报警规则',
                    id:'321', 
                    parentId:'31',
                    },{
                       icon:'',
                    name:'/AppAlarmClass',
                    path:'',
                    title:'报警分类',
                    id:'331', 
                    parentId:'31',
                    }
                    ]
                 },
                 {
                    icon:'',
                    name:'/AppIssue',
                    path:'',
                    title:'问题反馈',
                    id:'32', 
                    parentId:'3',
                    children:[{
                       icon:'',
                    name:'/AppIssue',
                    path:'',
                    title:'问题反馈',
                    id:'321', 
                    parentId:'32',
                    }]
                 }
                 ]
            },
            {
               icon:'icon-al-filter',
              name:'/AppAuth',
              path:'',
              title:'授权管理',
              id:'7', 
               children:[
                {
                   icon:'',
                    name:'/AppAuth',
                    path:'',
                    title:'授权管理',
                    id:'70', 
                    parentId:'7',
                    children:[
                    {
                     icon:'',
                    name:'/AppAuth',
                    path:'',
                    title:'应用授权',
                    id:'701', 
                    parentId:'70',
                     },
                     {
                     icon:'',
                    name:'/courseAuth',
                    path:'',
                    title:'课程授权',
                    id:'702', 
                    parentId:'70',
                     }
                    ]
                }
               ]
            },
            {
              icon:'icon-al-user-fill',
              name:'/User',
              path:'',
              title:'用户管理',
              id:'4', 
              children:[
                {
                   icon:'',
                    name:'/User',
                    path:'',
                    title:'用户管理',
                    id:'40', 
                    parentId:'4',
                     children:[{
                     icon:'',
                    name:'/User',
                    path:'',
                    title:'注册用户',
                    id:'401', 
                    parentId:'40',
                     },
                     ]
                },
                {
                  icon:'',
                    name:'/userClue',
                    path:'',
                    title:'线索管理',
                    id:'41', 
                    parentId:'4',
                     children:[{
                     icon:'',
                    name:'/userClue',
                    path:'',
                    title:'线索管理',
                    id:'411', 
                    parentId:'41',
                     },
                     {
                     icon:'',
                    name:'/Connection',
                    path:'',
                    title:'客户咨询',
                    id:'412', 
                    parentId:'41',
                     }
                     ]
                },
                {
                    icon:'',
                    name:'/Points',
                    path:'',
                    title:'积分管理',
                    id:'42', 
                    parentId:'4',
                    children:[{
                     icon:'',
                    name:'/Points',
                    path:'',
                    title:'积分管理',
                    id:'421', 
                    parentId:'42',
                     }]
                }
              ]
            },
             {
               icon:'icon-al-home',
                name:'/HomeWebsite',
                path:'',
                title:'官网管理',
                id:'5', 
                  children:[
                    {
                    icon:'',
                    name:'/HomeWebsite',
                    path:'',
                    title:'页面配置',
                    id:'50', 
                    parentId:'5',
                     children:[
                      {
                     icon:'',
                    name:'/HomeWebsite',
                    path:'',
                    title:'轮播图管理',
                    id:'501', 
                    parentId:'50',
                     },
                     {
                     icon:'',
                    name:'/viewConfig',
                    path:'',
                    title:'和隆优化主页展示配置',
                    id:'502', 
                    parentId:'50',
                     }, {
                     icon:'',
                    name:'/hlrjConfig',
                    path:'',
                    title:'和隆软件主页展示配置',
                    id:'503', 
                    parentId:'50',
                     },
                     {
                     icon:'',
                    name:'/TouchScreen',
                    path:'',
                    title:'触控屏内容',
                    id:'504', 
                    parentId:'50',
                     }
                     ]
                    },
                    {
                    icon:'',
                    name:'/Solution',
                    path:'',
                    title:'解决方案',
                    id:'51', 
                    parentId:'5',
                     children:[
                      {
                    icon:'',
                    name:'/Solution',
                    path:'',
                    title:'解决方案',
                    id:'511', 
                    parentId:'51',
                      },
                      {
                        icon:'',
                    name:'/SolutionClass',
                    path:'',
                    title:'解决方案分类',
                    id:'512', 
                    parentId:'51',
                      }
                     ]
                    },{
                    icon:'',
                    name:'/Case',
                    path:'',
                    title:'典型案例',
                    id:'54', 
                    parentId:'5',
                    children:[
                      {
                     icon:'',
                    name:'/Case',
                    path:'',
                    title:'经典案例',
                    id:'541', 
                    parentId:'54',  
                      }, {
                     icon:'',
                    name:'/CaseClass',
                    path:'',
                    title:'案例分类',
                    id:'542', 
                    parentId:'54',  
                      }
                    ]
                    },
                    {
                    icon:'',
                    name:'/News',
                    path:'',
                    title:'新闻动态',
                    id:'52', 
                    parentId:'5',
                    children:[
                      {
                    icon:'',
                    name:'/News',
                    path:'',
                    title:'新闻动态',
                    id:'521', 
                    parentId:'52',
                      },
                      {
                        icon:'',
                    name:'/NewsClass',
                    path:'',
                    title:'新闻分类',
                    id:'522', 
                    parentId:'52',
                      }
                    ]
                    },
                    {
                    icon:'',
                    name:'/recruit',
                    path:'',
                    title:'人才招聘',
                    id:'53', 
                    parentId:'5',
                    children:[
                       {
                    icon:'',
                    name:'/recruit',
                    path:'',
                    title:'人才岗位',
                    id:'531', 
                    parentId:'53',
                      },
                      {
                        icon:'',
                    name:'/recruitClass',
                    path:'',
                    title:'岗位分类',
                    id:'532', 
                    parentId:'53',
                      }
                    ]
                    }
                  ]
            },
             {
               icon:'icon-al-transanction',
              name:'/Transaction',
              path:'',
              title:'交易管理',
              id:'6', 
               children:[
                {
                   icon:'',
                    name:'/Transaction',
                    path:'',
                    title:'订单管理',
                    id:'60', 
                    parentId:'6',
                    children:[
                    {
                     icon:'',
                    name:'/Transaction',
                    path:'',
                    title:'订单列表',
                    id:'601', 
                    parentId:'60',
                     }
                    ]
                }
               ]
            },
            {
              icon:'icon-al-file-fill',
              name:'/testPapeList',
              path:'',
              title:'试卷管理',
              id:'8',
               children:[
                {
                  icon:'',
                    name:'/testPapeList',
                    path:'',
                    title:'试卷管理',
                    id:'80', 
                    parentId:'8',
                    children:[
                      {
                    icon:'',
                    name:'/testPapeList',
                    path:'',
                    title:'试卷列表',
                    id:'801', 
                    parentId:'80',
                      },{
                         icon:'',
                        name:'/testPaperClass',
                        path:'',
                        title:'试卷分类',
                        id:'802', 
                        parentId:'80',
                      }
                    ]
                },
                {
                    icon:'',
                    name:'/topicList',
                    path:'',
                    title:'题库管理',
                    id:'81', 
                    parentId:'8',
                    children:[
                      {
                    icon:'',
                    name:'/topicList',
                    path:'',
                    title:'题目列表',
                    id:'811', 
                    parentId:'81',
                      },
                      {
                    icon:'',
                    name:'/topicClass',
                    path:'',
                    title:'题目分类',
                    id:'812', 
                    parentId:'81',
                      },
                       {
                    icon:'',
                    name:'/topicImport',
                    path:'',
                    title:'批量导入',
                    id:'813', 
                    parentId:'81',
                      }
                    ]
                },{
                   icon:'',
                    name:'/simulationPaper',
                    path:'',
                    title:'仿真考试管理',
                    id:'82', 
                    parentId:'8',
                    children:[
                       {
                    icon:'',
                    name:'/simulationPaper',
                    path:'',
                    title:'仿真考试管理',
                    id:'821', 
                    parentId:'82',
                      },
                    ]
                }
               ]
            },
            {
                icon:'icon-al-news',
                name:'/ElectronicCard',
                path:'',
                title:'电子名片',
                id:'9', 
                 children:[{
                    icon:'',
                    name:'/ElectronicCard',
                    path:'',
                    title:'电子名片',
                    id:'90', 
                    parentId:'9',
                 }]
            },
             {
                icon:'icon-al-display-code',
                name:'/Course',
                path:'',
                title:'课程管理',
                id:'10', 
                 children:[
                      {
                    icon:'',
                    name:'/Course',
                    path:'',
                    title:'线上课',
                    id:'100', 
                    parentId:'10',
                   children:[
                     {
                    icon:'',
                    name:'/Course',
                    path:'',
                    title:'线上课',
                    id:'1000', 
                    parentId:'100',
                    },
                    {
                    icon:'',
                    name:'/courseClass',
                    path:'',
                    title:'线上课分类',
                    id:'1001', 
                    parentId:'100',
                  },
                   ] 
                 },
                  {
                    icon:'',
                    name:'/materialLibrary',
                    path:'',
                    title:'素材库',
                    id:'101', 
                    parentId:'10',
                    children:[
                       {
                    icon:'',
                    name:'/materialLibrary',
                    path:'',
                    title:'素材库',
                    id:'1010', 
                    parentId:'101',
                   },
                    {
                    icon:'',
                    name:'/materialLibraryClass',
                    path:'',
                    title:'素材库分类',
                    id:'1011', 
                    parentId:'101',
                   }
                    ]
                  },
                  {
                  icon:'',
                  name:'/certiFicate',
                  path:'',
                  title:'证书管理',
                  id:'102', 
                  parentId:'10',
                   children:[
                     {
                  icon:'',
                  name:'/certiFicate',
                  path:'',
                  title:'证书列表',
                  id:'1020', 
                  parentId:'102',
                    },
                    {
                  icon:'',
                  name:'/certiFicateClass',
                  path:'',
                  title:'证书分类',
                  id:'1030', 
                  parentId:'102',
                  },
                                    {
                  icon:'',
                  name:'/certiFicateStInfo',
                  path:'',
                  title:'证书学员信息',
                  id:'1040', 
                  parentId:'102',
                  }
                   ]
                  },
                 ]
            },
        ],
		}
	},
  watch: {
       $route() {
          if(this.$route){
        this.chative = this.$route.meta.parent.isShow ? this.$route.meta.parent.path : this.$route.path
         }
    }
  },
  created(){
    let that = this
   for (const key in this.treedata) {
    for (const i in this.treedata[key].children) {
      this.$nextTick(() => {
        that.activeNames.push(this.treedata[key].children[i].id)
      })
    }
   }
    this.chative = this.$route.meta.parent.isShow ? this.$route.meta.parent.path : this.$route.path
    this.active = this.$route.meta.index
    this.titname = this.$route.meta.title
    this.$bus.$emit("titname",this.titname);
  },
  methods: {
    handleChange(val){
      console.log(val)
    },
    openchilden(i,url,child){
      this.$router.push(url)
      this.active = i
     this.chative = url
    //  if(child[0].children){
    //   this.$bus.$emit("titname",child[0].children[0].title);
    //  }else{
    //    this.$bus.$emit("titname",child[0].title);
    //  }
    },
    // 打开页面
    openViews(url,child){

      this.chative = url
      this.$router.push(url)
      //  this.$bus.$emit("titname",this.$route.meta.title);
    },
  },
}
</script>
<style scoped lang="scss">
.leftclass{
      overflow-x: hidden;
    overflow-y: auto;
}
 /*滚动条样式*/
        .leftclass::-webkit-scrollbar {
            width: 4px;    
        }
        .leftclass::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            background: rgba(0,0,0,0.2);
        }
        .leftclass::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            border-radius: 0;
            background: rgba(255,255,255,0.1);

        }
.sider-logo{
  width: 80%;
  margin: 40px auto;
  display: block;
}
.rowlist{
  text-align: center;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  font-size: 14px;
  color: #c8c9cc;
  i{
    padding-right: 10px;
  }
}
  .current{
    background: #38f;
    color: #fff;
  }
  .cosspan{
    position: fixed;
    left: 120px;
    width: 120px;
    top: 0;
    height: calc(100vh - 60px);
    border-right: 1px solid #ebedf0;
    z-index: 999;
    overflow-x: hidden;
    overflow-y: auto;
    // box-shadow:0px 0px 3px rgba(0,0,0,.2);
    .cosspan-tit{
      width: 120px;
      height: 56px;
      color: #000;
       border-bottom: 1px solid #ebedf0;
       text-align: center;
       line-height: 56px;
    }
    .chcurrent{
      color: #323233;
    background-color: #ebedf0;
    }
  }
      /*滚动条样式*/
        .cosspan::-webkit-scrollbar {
            width: 4px;    
        }
        .cosspan::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
        }
        .cosspan::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);

        }
el-menu {
    background: none !important;
    border: none !important;

}
.el-menu--collapse{
    width: 54px;
}
.el-menu-item.is-active{
        color: #409EFF !important;
}
::v-deep{
   .nwap{
                        overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
            }
   .el-menu-item-group__title{
    padding: 0 !important;
   }
.el-menu--vertical{
     
    color: #FFF;
}
.el-collapse{
  border: none;
      cursor: pointer;
      padding-top: 10px;
          .el-collapse-item__header{
        color: #323233 !important;
        font-size: 14px;
           height: 30px;
           line-height: 30px;
           padding: 5px 0;
           padding-left: 20px;
      
      }
      .childItem-item,.elsetit{
         height: 30px;
           line-height: 30px;
           padding: 5px 0;
           font-size: 14px;
           text-align: center;
      }
      .el-collapse-item__content{
        color: #323233 !important;
        font-size: 14px;
      }
      .el-collapse-item__arrow{
        margin: inherit;
    margin-left: 10px;
      }
  .el-collapse-item__wrap{
    border: none;
  }
}
}
</style>  